import { useMantineColorScheme } from '@mantine/core'
import type * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react'

interface Props {
  option: echarts.EChartsOption
  height?: number | string
  style?: React.CSSProperties
}

/**
 * Mantine-themed ECharts wrapper. Uses 'dark' theme when color scheme is dark.
 */
export function Chart({ option, height = 280, style }: Props) {
  const { colorScheme } = useMantineColorScheme()
  const theme = colorScheme === 'dark' ? 'dark' : undefined
  return (
    <ReactECharts
      option={option}
      theme={theme}
      style={{ height, width: '100%', ...style }}
      opts={{ renderer: 'svg' }}
    />
  )
}
